import Vue from "vue";
import axios from "axios";
import qs from "qs";
import Util from "./util";
let _isJson = 0;
const baseUrl = process.env.NODE_ENV === "production" ? "" : "/api";
axios.defaults.timeout = 30000;
// axios.defaults.baseURL = "";
// axios.defaults.baseURL = "https://yizhuanbao-dev-web.itkyd.com";
axios.defaults.baseURL = "https://yizhuanbao-prod-app.itkyd.com";
// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    config.headers = {
      "Content-Type": _isJson
        ? "application/json"
        : "application/x-www-form-urlencoded",
      // token:'WQIardiMk3fX3aw8ymMcrS3dUGGgnFdQUTkxuXdRYfzga1n7eBLBe8Paz/DoGY9z'
      token: sessionStorage.getItem("part_token") ? sessionStorage.getItem("part_token") : "",
    };
    config.data = config.data;
    return config;
  },
  (error) => {
    return Promise.reject(err);
  }
);
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl + url, {
        params: Object.assign(params, {
          _: new Date().getTime(),
        }),
      })
      .then((response) => {
        response.data.httpTime =
          response.headers && response.headers.date
            ? response.headers.date
            : "";
        resolve(response.data);
      })
      .catch((err) => {
        if (err.response && err.response.data.code == 503) {
        } else {
          // Util.toast({
          //   msg: 'Network busy. Please try again later!',
          //   type: 'fail'
          // })
        }
      });
  });
}

export function post(url, data = {}, o, isJson) {
  _isJson = isJson;
  // o 是否是表单提交
  return new Promise((resolve, reject) => {
    axios.post(baseUrl + url, o ? data : qs.stringify(data)).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
        if (err.response && err.response.data.code == 503) {
        } else {
          Util.toast({
            msg: "Network busy. Please try again later!",
            type: "fail",
          });
        }
      }
    );
  });
}
